/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/CustomerUserProfile.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Current User Profile
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 10:05 PM (CST)
 *  
 *  Notes:
 *      09/15/2018  NJN     Working on clean up to split out or eliminate code.
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    CURRENTUSERPROFILE_EDIT_CONTAINER_LOADED,
    CURRENTUSERPROFILE_EDIT_CONTAINER_UNLOADED,
    CURRENTUSERPROFILE_EDIT_FORM_LOADED,
    CURRENTUSERPROFILE_EDIT_FORM_UNLOADED,
    CURRENTUSERPROFILE_EDIT_FORM_SUBMIT,
    CURRENTUSERPROFILE_OPEN_GENERATE_PASSWORD,
    CURRENTUSERPROFILE_CLOSE_GENERATE_PASSWORD,
    CURRENTUSERPROFILE_OPEN_GENERATE_PASSWORD_RESULTS,
    CURRENTUSERPROFILE_CLOSE_GENERATE_PASSWORD_RESULTS
} from '../constants/actionTypeCurrentUserProfile';

const defaultState = {
    refreshList: false,
    userstatuses: [],
    companies: [],
    generatePassword: false,
    userid: 0,
    companyid: 0,
    username: '',
    passwordexists: '',
    newpassword: '',
    refreshedpassword: '',
    firstname: '',
    middlename: '',
    lastname: '',
    userstatusid: 0,
    avatarid: 0,
    jobtitle: '',
    email: '',
    phone: '',
    lastlogin: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case CURRENTUSERPROFILE_EDIT_CONTAINER_LOADED:
            return {
                ...state,
                userstatuses: action.payload[1] ? action.payload[1].userstatuses : [],
                companies: action.payload[2] ? action.payload[2].companies : [],
                userid: action.payload[0] ? action.payload[0].userid : 0,
                companyid: action.payload[0] ? action.payload[0].companyid : 0,
                username: action.payload[0] ? action.payload[0].username : '',
                passwordexists: action.payload[0] ? action.payload[0].passwordexists : '',
                firstname: action.payload[0] ? action.payload[0].firstname : '',
                middlename: action.payload[0] ? action.payload[0].middlename : '',
                lastname: action.payload[0] ? action.payload[0].lastname : '',
                userstatusid: action.payload[0] ? action.payload[0].userstatusid : 0,
                avatarid: action.payload[0] ? action.payload[0].avatarid : 0,
                jobtitle: action.payload[0] ? action.payload[0].jobtitle : '',
                email: action.payload[0] ? action.payload[0].email : '',
                phone: action.payload[0] ? action.payload[0].phone : '',
                lastlogin: action.payload[0] ? action.payload[0].lastlogin : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case CURRENTUSERPROFILE_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case CURRENTUSERPROFILE_EDIT_FORM_SUBMIT:
            return {
                ...state,
                userid: action.payload ? action.payload.userid : 0,
                companyid: action.payload ? action.payload.companyid : 0,
                username: action.payload ? action.payload.username : '',
                passwordexists: action.payload ? action.payload.passwordexists : '',
                firstname: action.payload ? action.payload.firstname : '',
                middlename: action.payload ? action.payload.middlename : '',
                lastname: action.payload ? action.payload.lastname : '',
                userstatusid: action.payload ? action.payload.userstatusid : 0,
                avatarid: action.payload ? action.payload.avatarid : 0,
                jobtitle: action.payload ? action.payload.jobtitle : '',
                email: action.payload ? action.payload.email : '',
                phone: action.payload ? action.payload.phone : '',
                lastlogin: action.payload ? action.payload.lastlogin : '',
                createdate: action.payload ? action.payload.createdate : '',
                modifydate: action.payload ? action.payload.modifydate : ''
            }
        case CURRENTUSERPROFILE_OPEN_GENERATE_PASSWORD:
            return {
                ...state,
                generatePassword: true
            }
        case CURRENTUSERPROFILE_CLOSE_GENERATE_PASSWORD:
            return {
                ...state,
                generatePassword: false
            }
        case CURRENTUSERPROFILE_OPEN_GENERATE_PASSWORD_RESULTS:
            return {
                ...state,
                resultModal: true,
                refreshedpassword: action.newpassword,
                passwordexists: true
            }
        case CURRENTUSERPROFILE_CLOSE_GENERATE_PASSWORD_RESULTS:
            return {
                ...state,
                resultModal: false
            }
        case CURRENTUSERPROFILE_EDIT_CONTAINER_UNLOADED:
        case CURRENTUSERPROFILE_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/CurrentUserProfile.js